import { BusinessRules } from '../BusinessRules';

const rules: Partial<BusinessRules> = {
  mostrarProprietarioDivida: true,
};

export default rules;
